<template>
	<Col class="width-100 height-100 flex-centerize page-wrapper">
		<AppLoader v-if="isLoading" />
		<template v-else>
			<template v-if="isDone">
				<h1>Done</h1>
				<h3 class="text-center">You have successfully connected your account, you can now use <b>/ply</b> in Slack</h3>
			</template>
			<template v-else>
				<template v-if="mode === modes.currentAccount">
					<h3 class="text-center">Current workspace: {{ activeAccount.name }}</h3>
					<PrimaryButton @click="selectAccountInSlack(activeAccount.id)">Connect your account to Slack</PrimaryButton> <br />
					<OutlinedButton smallBtn @click="mode = modes.otherAccount">Switch workspace</OutlinedButton>
				</template>
				<template v-else>
					<WorkspaceSelectionMenu
						:activeAccount="{}"
						:joinedAccounts="joinedAccounts"
						@go-to-account="selectAccountInSlack"
						class="menu-content-container height-100"
						title="Select a Ply workspace to be used in Slack"
					/>
					<OutlinedButton smallBtn @click="mode = modes.currentAccount">Back</OutlinedButton>
				</template>
			</template>
		</template>
	</Col>
</template>

<script>
import api from '@/api';
import { SLACK_WORKSPACE_SELECTION_ROUTE_NAME } from '@/router/router.const.js';
import WorkspaceSelectionMenuMixin from '@/components/WorkspaceSelectionMenu/mixins/WorkspaceSelectionMenuMixin.js';
import { mapGetters } from 'vuex';

const MODES = {
	currentAccount: 'currentAccount',
	otherAccount: 'otherAccount',
};

export default {
	name: SLACK_WORKSPACE_SELECTION_ROUTE_NAME,
	mixins: [WorkspaceSelectionMenuMixin],
	props: {
		token: { type: String, required: true },
	},
	computed: {
		...mapGetters(['user']),
		modes() {
			return MODES;
		},
	},
	methods: {
		async selectAccountInSlack(accountId = this.activeAccount.id) {
			try {
				this.isLoading = true;
				await api.selectWorkspaceForSlack(this.user.id, this.token, accountId);
				this.isDone = true;
			} catch (e) {
				const errMsg = e.response?.data?.message || e.message;
				this.$toast.error(`Failed to select workspace: ${errMsg}`);
				throw e;
			} finally {
				this.isLoading = false;
			}
		},
	},
	data() {
		return {
			isLoading: false,
			isDone: false,
			mode: MODES.currentAccount,
		};
	},
};
</script>

<style scoped lang="scss">
.menu-content-container {
	max-height: 360px;
	$menu-width: 490px;
	width: $menu-width;
	min-width: $menu-width;
	max-width: $menu-width;
}
::v-deep {
	.inner-content {
		h5 {
			font-size: 22px;
			line-height: 26px;
		}
		h3 {
			display: flex;
		}
	}
	.slot-card {
		overflow: hidden;
		min-height: 359px;
		padding: 0px !important;
	}
	.inner-content {
		padding: 18px 30px 30px 30px !important;
	}
	.footer-button {
		display: none; // TODO slack - put it in vue-shared-components
	}
	.suffix {
		display: none; // TODO slack - put it in vue-shared-components
	}
}
.page-wrapper {
	width: 100vw;
	height: 100vh;
	overflow: hidden;
}
</style>
